/**
 * O que faz: Pesquisa/pagina anúncios somente enquanto o detalhe está aberto.
 * Onde usa: Modal de performance de anúncios.
 * Conexões: React Query, contexto de sessão e RPC get_dashboard_anuncios_v1.
 * Tabelas: SELECT agregado de leads/agenda/aliases protegido pelo RLS.
 * Data: 31/08/2026.
 */
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ContextoDashboard } from '@/features/dashboard/data/dashboardContracts';
import { buscarAnunciosDashboard, type FiltrosAnunciosDashboard } from '@/services/dashboardResumoService';
import { chaveContextoDashboard } from './useDashboardConsultas';

export function useAnunciosDashboard(contexto: ContextoDashboard | undefined, filtros: FiltrosAnunciosDashboard & { aberto: boolean }) {
  const [buscaAplicada, setBuscaAplicada] = useState(filtros.busca);
  useEffect(() => {
    // Digitação rápida consulta uma vez após 250 ms, sem iniciar uma leitura por tecla.
    const timer = setTimeout(() => setBuscaAplicada(filtros.busca), 250);
    return () => clearTimeout(timer);
  }, [filtros.busca]);
  const consulta = useQuery({
    queryKey: ['dashboard-v1', ...chaveContextoDashboard(contexto), 'anuncios', contexto?.periodo, buscaAplicada, filtros.ordem, filtros.direcao, filtros.pagina, filtros.tamanho],
    queryFn: ({ signal }) => buscarAnunciosDashboard(contexto!, { ...filtros, busca: buscaAplicada }, signal),
    enabled: !!contexto && filtros.aberto && buscaAplicada === filtros.busca,
    staleTime: 60_000, gcTime: 5 * 60_000, retry: 1, refetchOnWindowFocus: false,
  });
  // Enquanto a busca muda, não expor uma página pertencente ao texto anterior.
  const digitando = buscaAplicada !== filtros.busca;
  return { ...consulta, data: digitando ? undefined : consulta.data, isLoading: consulta.isLoading || digitando, isFetching: consulta.isFetching || digitando };
}
